import script from "./SecureSect.vue?vue&type=script&lang=ts&setup=true"
export * from "./SecureSect.vue?vue&type=script&lang=ts&setup=true"

import "./SecureSect.vue?vue&type=style&index=0&id=1cfcf574&lang=scss"

const __exports__ = script;

export default __exports__